import { PropsWithChildren } from "react";

import { rem } from "polished";
import styled, { css } from "styled-components";

import { color, font, spaces } from "emoreg/const";
import { radius } from "styles/const";

const generateTagStyle = backgroundColor => textColor => {
  return css`
    background: ${backgroundColor};
    color: ${textColor};
  `;
};

class TypesMapping {
  primary = generateTagStyle(color.blue.base)("#fff");
  secondary = generateTagStyle(color.grey.dark)("#fff");
  neutral = generateTagStyle(color.grey.light)(color.grey.dark);
  info = generateTagStyle("#17a2b8")("#fff");
  danger = generateTagStyle(color.red.base)("#fff");
  dangerCovid = generateTagStyle("#fff")(color.red.base);
  successCovid = generateTagStyle("#fff")("#128A0C");
  cancel = generateTagStyle("#FA8700")("#fff");
  dark = generateTagStyle("#343a40")("#fff");
  success = generateTagStyle("#128A0C")("#fff");
  warning = generateTagStyle(color.orange.dark)("#fff");
  tertiary = generateTagStyle(color.grey.base)("#fff");
  light = generateTagStyle("#fff")(color.grey.dark);
}

const typesMapping = new TypesMapping();
type TagTypes = keyof TypesMapping;

const TagStyle = styled.span`
  font-size: ${rem(12)};
  padding: ${spaces[4]} ${spaces[8]};
  font-weight: ${font.weight.semiBold};
  border-radius: ${radius.lg};
  white-space: nowrap;
  ${({ type }: { type: TagTypes }) => typesMapping[type]}
`;

type TagProps = { type: TagTypes; style?: React.CSSProperties; title?: string };
/**
 * @deprecated use Tag from emoreg/atoms/Tag instead
 */
export const Tag = ({ children, type, style, title }: PropsWithChildren<TagProps>) => (
  <TagStyle style={style} type={type} title={title}>
    {children}
  </TagStyle>
);
